import React, { useEffect, useState } from "react";
import { firestore } from "../../firebase/config";
import { arrayUnion, doc, getDoc, updateDoc } from "firebase/firestore";
import CompleteProfile from "./components/CompleteProfile";
import Loading from "../../components/loading/Loading";
import { FaRegCalendarCheck } from "react-icons/fa";
import Button from "../../components/Button";

const MixerRegistration = ({
  user,
  handleSubmitted,
  tournamentId,
  tournament,
}) => {
  const [userProfile, setUserProfile] = useState(undefined);

  useEffect(() => {
    if (!user?.uid) {
      return;
    }

    const fetchUserProfile = async () => {
      const profilesRef = doc(firestore, "profiles", user.uid);

      try {
        const docSnap = await getDoc(profilesRef);
        if (docSnap.exists()) {
          setUserProfile(docSnap.data());
        } else console.log("No profile found for current user");
      } catch (error) {
        console.log(error);
      }
    };

    fetchUserProfile();
  }, [user?.uid]);

  const register = async () => {
    if (!user.uid) {
      alert("Must be signed and have a completed profile to register!");
    }

    const submitButton = document.getElementById("mixer-registration-button");
    submitButton.disabled = true;

    const tournamentRef = doc(firestore, "tournaments", tournamentId);

    try {
      await updateDoc(tournamentRef, {
        playerIds: arrayUnion(user.uid),
      });

      handleSubmitted(true);
    } catch (error) {
      console.log(error);
      alert("Your registration was not successful", error.message);
    }
  };

  if (!userProfile?.name) {
    return <Loading />;
  }

  if (
    !userProfile?.name ||
    !userProfile?.pronouns ||
    !userProfile?.region ||
    !userProfile?.skill
  ) {
    <CompleteProfile />;
  }

  return (
    <div className="w-11/12 flex justify-center">
      <div className="flex flex-col max-w-md w-full bg-white mt-12 p-10 items-center rounded-2xl shadow-2xl border border-indigo-400">
        <FaRegCalendarCheck className="text-indigo-500 text-6xl mb-8" />

        <h2 className="text-3xl font-bold text-center text-gray-900 mb-6">
          {tournament.name}
        </h2>

        <p className="text-center text-gray-600 mb-2">
          {tournament.startDate} - {tournament.endDate}
        </p>

        <p className="text-center text-gray-600 mb-2">{tournament.location}</p>

        <Button
          color="indigo"
          id="mixer-registration-button"
          onClick={register}
        >
          Register Now
        </Button>
      </div>
    </div>
  );
};

export default MixerRegistration;
